import React, { useEffect, useMemo, useRef } from 'react';
import { PageShell } from './PanelLayout';
import { buildPublicFormUrl } from './publicFormApplicationApi';

const parseMessageData = (data) => {
  if (!data) return null;

  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }

  if (typeof data === 'object') {
    return data;
  }

  return null;
};

const PublicFormSrcIframe = ({
  applicationTitle,
  publicApplicationType,
  deeplinkMeta,
  recaptchaToken,
  onMessage,
}) => {
  const iframeRef = useRef(null);
  const iframeSrc = useMemo(() => {
    if (!publicApplicationType?.url || !recaptchaToken) return null;

    return buildPublicFormUrl({
      publicApplicationType,
      deeplinkMeta,
      recaptchaToken,
    }).toString();
  }, [deeplinkMeta, publicApplicationType, recaptchaToken]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleMessage = (event) => {
      if (event.source !== iframeRef.current?.contentWindow) return;

      const payload = parseMessageData(event.data);
      if (!payload) return;

      onMessage?.({
        origin: event.origin,
        payload,
      });
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onMessage]);

  if (!iframeSrc) return null;

  return (
    <PageShell>
      <iframe
        ref={iframeRef}
        title={applicationTitle}
        src={iframeSrc}
        allow="fullscreen *; clipboard-write *; camera *; microphone *; geolocation *; payment *"
        referrerPolicy="no-referrer-when-downgrade"
        className="h-full min-h-[calc(100vh-5rem)] w-full flex-1 border-0"
      />
    </PageShell>
  );
};

export default PublicFormSrcIframe;
